import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { RestaurantSettings } from '../../../libs/proto/restaurant_pb';

@Injectable({
  providedIn: 'root'
})
export class RestaurantSettingsConversionService {

  constructor() { }

  ToStorage(req: RestaurantSettings) {
    const w = new BinaryWriter();
    RestaurantSettings.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (c: RestaurantSettings, errorConvert: any) => void) {
    try {
      callback( RestaurantSettings.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }
}
